import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import * as Yup from "yup";
import Select from "react-select";
import * as manageuserConsts from "./usermanagementconst";
import { updateCommonInfo } from "../../../redux/commonSlice";
import { httpGetConfigValues } from "../../../service/httpClient";
import { TooltipIcon } from "../../../assets/js/image";
import "../../Common/Tooltip/ToolTip.css";

import {
  SimilarAddresses,
  defaultAutoCompleteFieldChange,
  defaultOnSelectAddress,
  handleValidate,
  //consturctAddressState,
} from "../../../components/VendorOnboarding/Views/Address/helpers";

export const phoneRegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
export const emailValidationRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const nameRegExp = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]?|[A-Za-z`~!@#$%^&*()=+\{\}\[\]\\|;:'",<.>//?_-\s])*$/;

export function FieldLableToolTip(props) {
  const { id, label, required, toolTipText } = props;
  return (
    <Form.Label id={id} className="tooltip frm-label">
      {label}
      {required && <span className="required">*</span>}
      {toolTipText && (
        <span className="tooltiptext">
          <TooltipIcon />
          {toolTipText}
        </span>
      )}
    </Form.Label>
  );
}

export default function TextField(props) {
  const {
    field,
    handleChange,
    handleValidateFields,
    formValues,
    setFormValues,
    setDisableSave,
    allFieldsObj,
    validationSchema,
  } = props;
  const { errors } = formValues || "";
  const {
    id,
    label,
    type,
    placeHolder,
    value,
    disabled = false,
    readonly = false,
    required = false,
    min = false,
    max = false,
    class: cls = "mb-4 form-grid-items",
    toolTipText = "",
  } = field || "";

  let addonAttributes = {};
  if (min) {
    addonAttributes.minLength = min;
  }

  if (id.toLowerCase().includes("phone")) {
    addonAttributes.maxLength = 10;
  } else if (max) {
    addonAttributes.maxLength = max;
  }

  return (
    <Form.Group className={cls} controlId={id} key={id}>
      <FieldLableToolTip
        id={id}
        label={label}
        required={required}
        toolTipText={toolTipText}
      />

      <Form.Control
        type={type}
        placeholder={placeHolder}
        value={typeof formValues[id] !== "undefined" ? formValues[id] : value}
        disabled={disabled}
        readOnly={readonly}
        onBlur={(e) => {
          handleValidateFields(
            {
              field,
              fieldValue: e.target.value,
            },
            {
              formValues,
              setFormValues,
              setDisableSave,
              allFieldsObj,
              validationSchema,
            }
          );
        }}
        onChange={(e) => {
          handleChange(e, {
            formValues,
            setFormValues,
            setDisableSave,
            allFieldsObj,
          });
        }}
        {...addonAttributes}
      />
      {errors && errors[id] && (
        <div key={id} className="err-field-container cls-err">
          {errors[id]}
        </div>
      )}
    </Form.Group>
  );
}

export function getDbConfigOptions(props) {
  const { options = {}, dynamicOptionLable } = props || {};
  const [optionObj, setOptionObj] = useState(options);

  const dispatch = useDispatch();
  const store = useSelector(
    ({ service, common }) => ({
      configValues: common.configValues,
    }),
    shallowEqual
  );
  useEffect(() => {
    if (store?.configValues?.length === 0) {
      httpGetConfigValues().then((response) => {
        if (response?.data) {
          dispatch(
            updateCommonInfo({
              configValues: response.data,
            })
          );
          let selectOptions = getFilteredConfigByKey(
            response?.data,
            dynamicOptionLable
          );
          setOptionObj(selectOptions);
        }
      });
    }
  }, []);

  if (
    dynamicOptionLable &&
    store?.configValues?.length > 0 &&
    Object.keys(optionObj).length === 0
  ) {
    //Prepare data for dropdown
    let selectOptions = getFilteredConfigByKey(
      store?.configValues,
      dynamicOptionLable
    );
    setOptionObj(selectOptions);
  }

  return optionObj;
}

export function getFilteredConfigByKey(optionObj, configKey) {
  if (Object.keys(optionObj).length > 0 && configKey) {
    let selectOptions = Object.values(optionObj)
      .filter((res) => res.key.indexOf(configKey) > -1)
      .map((val) => {
        return JSON.parse(val.value);
      });
    return selectOptions[0];
  }
  return optionObj;
}

export function SelectField(props) {
  const {
    field,
    handleChange,
    handleValidateFields,
    formValues,
    setFormValues,
    setDisableSave,
    allFieldsObj,
    validationSchema,
  } = props;
  const { errors } = formValues || "";
  const {
    id,
    label,
    disabled = false,
    readonly = false,
    options = {},
    value = "",
    disabledOpt = "",
    placeHolder = "Select...",
    required = false,
    dynamicOptionLable = false,
    class: cls = "mb-4 form-grid-items",
    toolTipText = "",
  } = field || "";

  let selectedOpt =
    typeof formValues[id] !== "undefined" ? formValues[id] : value;

  let optionObj =
    Object.keys(options).length === 0 && dynamicOptionLable
      ? getDbConfigOptions({
          dynamicOptionLable: dynamicOptionLable,
        })
      : options;

  return (
    <Form.Group className={cls} size="lg" controlId={id} key={id}>
      <FieldLableToolTip
        id={id}
        label={label}
        required={required}
        toolTipText={toolTipText}
      />
      <select
        id={id}
        name={id}
        className="form-control"
        disabled={disabled}
        readOnly={readonly}
        onChange={(e) => {
          handleChange(e, {
            formValues,
            setFormValues,
            setDisableSave,
            allFieldsObj,
          });
          handleValidateFields(
            {
              field,
              fieldValue: e.target.value,
            },
            {
              formValues,
              setFormValues,
              setDisableSave,
              allFieldsObj,
              validationSchema,
            }
          );
        }}
        onBlur={(e) => {
          handleValidateFields(
            {
              field,
              fieldValue: e.target.value,
            },
            {
              formValues,
              setFormValues,
              setDisableSave,
              allFieldsObj,
              validationSchema,
            }
          );
        }}
      >
        <option value="" selected={!selectedOpt} disabled>
          {placeHolder}
        </option>
        {Object.keys(optionObj).length > 0 ? (
          optionObj.map((option, index) => {
            let optLable = dynamicOptionLable ? option?.value : option?.label;
            let optVal = dynamicOptionLable ? option?.name : option?.value;
            let selectOptions = {};
            selectOptions = (
              <option
                value={optVal}
                disabled={optVal === disabledOpt}
                selected={optVal === selectedOpt}
                key={index}
              >
                {optLable}
              </option>
            );
            return selectOptions;
          })
        ) : (
          <option value="" disabled>
            {manageuserConsts.NO_DATA}
          </option>
        )}
      </select>
      {errors && errors[id] && (
        <div key={id} className="err-field-container cls-err">
          {errors[id]}
        </div>
      )}
    </Form.Group>
  );
}

export function PasswordField(props) {
  const {
    field,
    handleChange,
    handleValidateFields,
    formValues,
    setFormValues,
    setDisableSave,
    allFieldsObj,
    validationSchema,
  } = props;
  const {
    id,
    label,
    type,
    placeHolder,
    required = false,
    class: cls = "mb-4 form-grid-items",
    toolTipText = "",
  } = field || "";
  const { errors } = formValues || "";
  return (
    <Form.Group className={cls} controlId={id} key={id}>
      <FieldLableToolTip
        id={id}
        label={label}
        required={required}
        toolTipText={toolTipText}
      />
      <Form.Control
        type={type}
        placeholder={placeHolder}
        onBlur={(e) => {
          handleValidateFields(
            {
              field,
              fieldValue: e.target.value,
            },
            {
              formValues,
              setFormValues,
              setDisableSave,
              allFieldsObj,
              validationSchema,
            }
          );
        }}
        onChange={(e) => {
          handleChange(e, {
            formValues,
            setFormValues,
            setDisableSave,
            allFieldsObj,
          });
        }}
      />
      {errors && errors[id] && (
        <div key={id} className="err-field-container cls-err">
          {errors[id]}
        </div>
      )}
    </Form.Group>
  );
}

const AddressFields = (props) => {
  const { addressTypes = ["primary"], addressIndex, required = true } = props;
  return addressTypes.map((type) => {
    const index = !isNaN(addressIndex) ? addressIndex : "";
    return [
      {
        fieldId: `streetAddress`,
        fieldLabel: "Address",
        required: required,
        length: 4,
        placeHolder: "5985 State Bridge Rd",
        fieldType: "text",
        automationId: `${type.toLowerCase()}Address`,
        key: `streetAddress_${type.toLowerCase()}${index}`,
      },
      {
        fieldId: "suiteUnitFloor",
        fieldLabel: "Unit",
        length: 1,
        required: false,
        placeHolder: "11",
        fieldType: "text",
        automationId: `${type.toLowerCase()}Suite`,
        key: `suiteUnitFloor_${type.toLowerCase()}${index}`,
      },
      {
        fieldId: "city",
        fieldLabel: "City",
        length: 2,
        required: required,
        placeHolder: "Duluth",
        fieldType: "text",
        automationId: `${type.toLowerCase()}City`,
        key: `city_${type.toLowerCase()}${index}`,
        disabled: true,
      },
      {
        fieldId: "state",
        fieldLabel: "State/Province",
        length: 2,
        maxLength: 2,
        required: required,
        placeHolder: "GA",
        fieldType: "text",
        automationId: `${type.toLowerCase()}State`,
        key: `state_${type.toLowerCase()}${index}`,
        disabled: true,
      },
      {
        fieldId: "zipCode",
        fieldLabel: "Zip",
        length: 2,
        required: required,
        placeHolder: "30097",
        fieldType: "text",
        automationId: `${type.toLowerCase()}ZipCode`,
        key: `zipCode_${type.toLowerCase()}${index}`,
        disabled: true,
      },
      {
        fieldId: "country",
        fieldLabel: "Country",
        length: 1,
        maxLength: 2,
        required: required,
        placeHolder: "US",
        fieldType: "text",
        automationId: `${type.toLowerCase()}Country`,
        key: `country_${type.toLowerCase()}${index}`,
        disabled: true,
      },
    ];
  });
};

export function AddressAutocompleteField(props) {
  const {
    addressTypes = ["primary"],
    formValues = {
      primaryAddress: {
        streetAddress: "",
        suiteUnitFloor: "",
        city: "",
        state: "",
        zipCode: "",
        country: "",
      },
    },
    setFormValues,
    pageFrom,
    field,
  } = props || "";

  const { disabled: disableFields, required, class: cls } = field || "";

  let fieldObj = AddressFields({
    addressTypes: addressTypes,
    required: required,
  });

  return fieldObj.map((address) => {
    const addressType =
      typeof address[0] !== "undefined" ? address[0]?.automationId : "";

    return (
      <Form.Row key={addressType} className="mb-4">
        <SimilarAddresses
          handleValidate={handleValidate}
          errors={formValues.errors}
          address={address}
          formValues={formValues}
          disableFields={disableFields}
          fieldValueObject={formValues[addressType]}
          setFormValues={setFormValues}
          onAutoCompleteChange={defaultAutoCompleteFieldChange}
          onSelectAddress={(selectedAddress, props) => {
            defaultOnSelectAddress(selectedAddress, props);
          }}
          //setCoordinates={setCoordinates}
          pageFrom={pageFrom}
          cls={cls}
        />
      </Form.Row>
    );
  });
}

export function FormButton(props) {
  const {
    id,
    parentElemCls = "mb-4 form-grid-items",
    btnCls = "mcy-btn-primary create-btn",
    label,
    disabled,
    onClick,
  } = props || "";
  return (
    <Form.Group className={parentElemCls} controlId={id}>
      <Button className={btnCls} onClick={onClick} disabled={disabled}>
        {label}
      </Button>
    </Form.Group>
  );
}

export const PageSection = (props) => {
  const { title } = props;
  return (
    <div className="col-md-12 mt-2">
      <div className="border-b col-md-12 pageSection">
        <label className="sectionTitle">{title}</label>
      </div>
    </div>
  );
};

export const formatPhone = (phoneNumber) => {
  if (phoneNumber.replace(/\D/g, "").length === 10) {
    let temp = phoneNumber
      .replace("(", "")
      .replace(")", "")
      .replace("-", "");
    let pn =
      "(" + temp.slice(0, 3) + ") " + temp.slice(3, 6) + "-" + temp.slice(6);

    return pn === "()-" ? "" : pn;
  } else {
    return phoneNumber.replace(/\D/g, "");
  }
};

export const handleChange = (e, addOnProps) => {
  let fieldid = e.target?.id || "";
  let val = e.target?.value || "";

  const {
    formValues,
    setFormValues,
    setDisableSave,
    allFieldsObj,
  } = addOnProps;

  if (fieldid.toLowerCase().includes("phone")) {
    val = formatPhone(val);
  }

  let modFormValues = formValues || {};
  modFormValues[fieldid] = val;

  setFormValues({
    ...formValues,
    modFormValues,
  });

  setDisableSave(
    validateForm({ fieldsObj: allFieldsObj, formValues: modFormValues })
      ? false
      : true
  );
};

export const handleValidateFields = (fieldInfo, addOnProps) => {
  const { field, fieldValue } = fieldInfo;
  const {
    formValues,
    setFormValues,
    setDisableSave,
    allFieldsObj,
    validationSchema,
  } = addOnProps;
  let { id } = field;

  Yup.reach(validationSchema, `${[id]}`)
    .validate(fieldValue)
    .then((value) => {
      let errorsObj = { ...formValues?.errors };
      errorsObj?.id && delete errorsObj[id];

      setFormValues((state) => {
        state.errors[id] && delete state.errors[id];
        return {
          ...state,
        };
      });
      setDisableSave(
        validateForm({ fieldsObj: allFieldsObj, formValues: formValues })
          ? false
          : true
      );
    })
    .catch((err) => {
      let errorsObj = {};
      errorsObj[id] = err.message;

      setFormValues((state) => ({
        ...state,
        errors: {
          ...state.errors,
          ...errorsObj,
        },
      }));
      setDisableSave(true);
    });
};

export const validateForm = (props) => {
  let { fieldsObj, formValues } = props;

  //check if all the required fields have values
  let fieldListToValidate = fieldsObj
    .filter(function(el) {
      return el.validateInForm === true && el.id;
    })
    .map(function(el) {
      return el.id;
    });

  let errCount = 0;
  fieldListToValidate.forEach((field) => {
    if (typeof formValues[field] === "undefined" || formValues[field] === "") {
      errCount++;
    }
  });

  return errCount === 0 && Object.keys(formValues?.errors).length === 0
    ? true
    : false;
};

export const SelectFieldReactComp = (props) => {
  const {
    id,
    options,
    placeholder,
    onChange,
    value,
    isMulti = false,
    cls = "",
    openOnFocus = false,
    required = false,
    label,
    toolTipText = "",
  } = props || {};
  return (
    <div>
      <FieldLableToolTip
        id={id}
        label={label}
        required={required}
        toolTipText={toolTipText}
      />
      <Select
        inputId={id}
        options={options}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        isMulti={isMulti}
        className={cls}
        openOnFocus={openOnFocus}
      />
    </div>
  );
};

export const getPrepareOptionsForReactDp = (dataObj, valueCol, lableCol) => {
  let options = [];
  if (Object.keys(dataObj).length > 0) {
    dataObj.forEach((objVal) => {
      options.push({
        value: objVal[valueCol],
        label: objVal[lableCol],
        addonParms: objVal,
      });
    });
  }
  return options;
};

export function FieldsGenerator(props) {
  const {
    fieldObj,
    formValues,
    setFormValues,
    handleValidateFields,
    handleChange,
    setDisableSave,
    allFieldsObj,
    validationSchema,
  } = props;
  if (typeof fieldObj.type !== "undefined") {
    let field = {};
    switch (fieldObj.type) {
      case "text":
        field = (
          <TextField
            field={fieldObj}
            handleValidateFields={handleValidateFields}
            handleChange={handleChange}
            formValues={formValues}
            setFormValues={setFormValues}
            setDisableSave={setDisableSave}
            allFieldsObj={allFieldsObj}
            validationSchema={validationSchema}
          />
        );
        break;
      case "select":
        field = (
          <SelectField
            field={fieldObj}
            handleValidateFields={handleValidateFields}
            handleChange={handleChange}
            formValues={formValues}
            setFormValues={setFormValues}
            setDisableSave={setDisableSave}
            allFieldsObj={allFieldsObj}
            validationSchema={validationSchema}
          />
        );
        break;
      case "password":
        field = (
          <PasswordField
            field={fieldObj}
            handleValidateFields={handleValidateFields}
            handleChange={handleChange}
            formValues={formValues}
            setFormValues={setFormValues}
            setDisableSave={setDisableSave}
            allFieldsObj={allFieldsObj}
            validationSchema={validationSchema}
          />
        );
        break;
      case "addressAutocomplete":
        field = (
          <AddressAutocompleteField
            field={fieldObj}
            formValues={formValues}
            setFormValues={setFormValues}
            setDisableSave={setDisableSave}
          />
        );
        break;
      default:
        break;
    }
    return field;
  }
  return false;
}
